export const cooperate = {
    cooperate: '商业合作',
    title: '福昕家装，扬帆启航',
    subtitle: '诚邀各方参与，共建双赢生态',
    cooperateImmediately: '立即合作',
    introduceTitle: '我们是谁',
    introduceDesc:
        '福昕家装（FoxitHD）致力于以一体化、标准化、数智化破局，加快建造方式转变，推动家装行业高质量发展，志在为家装行业摘掉“散乱差”标签。现诚邀各界合作，助推家装行业变革，一起开启移动互联网家装新时代。',
    mobileProduct: '智能设计·移动端',
    mobileProductDesc: '随身必备的装修3D设计运营神器',
    desktopProduct: '智能设计·桌面端',
    desktopProductDesc: '智能化、BIM化室内设计软件',
    personalProduct: '云服务·尊享版',
    personalProductDesc: '为品质家装提供个性化项目管理服务',
    businessProduct: '云服务·企业版',
    businessProductDesc: '数据赋能装企，专注项目生命周期管理',
    rightsTitle: '合作权益',
    popularize: '品牌推广',
    popularizeDesc: '官网流量助力品牌推广',
    discount: '产品折扣',
    discountDesc: '购买福昕家装旗下产品享有优惠折扣',
    share: '商机共享',
    shareDesc: '客户商机全面共享',
    authorization: '品牌授权',
    authorizationDesc: '福昕家装官方认证资格并颁发授权证书',
    support: '系统支持',
    supportDesc: 'SVIP先行内测，提供过程版本、专业技术支持等',
    requirementTitle: '合作要求',
    aptitude: '公司资质',
    aptitudeDesc: '具有合法营业执照和独立法人代表，良好的企业形象和信誉',
    team: '专业团队',
    teamDesc: '接受福昕的培训与认证，拥有专业的服务团队',
    resource: '客户资源',
    resourceDesc: '拥有较为丰富的客户资源',
    approval: '企业认同',
    approvalDesc: '认同福昕企业文化，愿与福昕家装长期合作、一同成长',
    progressTitle: '加入流程',
    application: '提交申请',
    review: '资料审核',
    sign: '签约合同',
    training: '平台培训',
    partner: '生态合作伙伴',
    operateTitle: '加速成为合作伙伴！',
    settled: '商家入驻',
    settledTitle: '福昕家装，火热招商',
    settledSubTitle: '诚邀品牌入驻，携手数字化，共赴新征程',
    settledButton: '立即入驻',
    workTitle: '我们在做什么',
    workDesc:
        '福昕家装·智能设计，是一款家装行业桌面端智能化、BIM化室内设计软件，内置真实商品信息，从设计到施工，通过福昕家装·云服务面向全角色，实现在线信息沟通、设计效果展现、批注、RFI、实时查看施工进度，助力企业数字化转型升级。欢迎各品牌厂商入驻福昕家装，上传真实模型，拓宽曝光渠道为品牌引流。',
    reason: '为什么要入驻',
    reasonDesc: '家装行业设计、施工、协同解决方案',
    reason1: '品牌主页个性化呈现',
    reason2: '商品模型数字化、标准化',
    reason3: '设计师资源深度合作',
    reason4: '全网流量红利',
    settledProgress: '入驻流程',
    settledProgressTitle1: '入驻申请',
    settledProgressDesc1: '点击入驻按钮，填写入驻申请信息后提交',
    settledProgressTitle2: '入驻审核',
    settledProgressDesc2: '后台人员接收信息后，专人联系您完成验证',
    settledProgressTitle3: '后台配置',
    settledProgressDesc3: '信息审核通过后，后台完成账号开通',
    settledProgressTitle4: '入驻完成',
    settledProgressDesc4: '使用账号登录，完善信息后完成入驻',
    settledProgressTitle5: '课程学习',
    settledProgressDesc5: '入驻后需要学习软件功能操作、模型上传规范等相关课程',
    cooperateSettled: '相约福昕家装，共创美好未来！',
    settledImmediately: '立即入驻',
    modal: {
        operationTitle: '商务合作信息',
        applyBusinessCooperation: '申请商务合作',
        settledTitle: '商务入驻信息',
        placeHolder: {
            enterpriseName: '请输入您所在的企业名称',
            fullName: '请输入您的姓名',
            duty: '请输入您的职务',
            mobile: '请输入您的手机号码',
        },
        submit: '提交',
        success: '提交成功！',
        emptyPrompt: '信息不能为空',
        phoneInvalid: '手机号码格式不正确',
        prompt: '唤醒微信客服，回复“问题关键词序号”</br>可加快申请通过速度',
        awakeService: '点击去唤醒',
    },
    settleRightsTitle: '入驻权益',
    displayBand: '品牌展示',
    displayBandDesc:
        '品牌展现在福昕家装官网模型库详情页、智能设计软件及家装云服务宣传页面',
    flowSupport: '流量支持',
    flowSupportDesc: '福昕家装全网流量支持',
    dataSupport: '数据支持',
    dataSupportDesc: '提供及时、有效、权威的数据支持',
    trainSupport: '培训支持',
    trainSupportDesc: '定期给予入驻商家专业培训',
    settleRequirementTitle: '入驻要求',
    modalResource: '模型资源',
    modalResourceDesc:
        '拥有较为丰富的自主版权模型资源，愿与福昕家装共同打造模型库',
    account: '企业账号',
    accountDesc: '需开通福昕家装云服务企业版账号',
};
